/** @jsxImportSource theme-ui */
import { Container, Heading } from 'theme-ui';
import CompanyServicesArticles from '@/containers/companyServicesArticles/CompanyServicesArticles';

const CompanyServicesArticlesPage = () => {
    return (
        <Container>
            <Heading as="h2">Services & articles</Heading>
            <CompanyServicesArticles />
        </Container>
    );
};

export default CompanyServicesArticlesPage;
